module.exports = __webpack_public_path__ + "img/ContBlockImg.3b30287b.png";